import {getAllAxisValues} from '../layout/utils/axisValues';
import {
  getCombinedHistorySpecs,
  getNoRequiredRunNames,
  getPanelMediaKeys,
  shouldAlwaysFilterRunsInQuery,
} from './queryConfigHelpers';
import {getGridLoadTier} from './trackingConfigHelper';
import {type MediaPanelModeConfig} from './types';

export const gridModeConfig: MediaPanelModeConfig = {
  imageFitAndResolutionConfigFields: ['alwaysOriginal', 'default'],
  filterToRunsWithMediaKey: true,
  // Grid manages row heights so height-filling media (video) isn't squished.
  constrainsContentRowHeight: true,
  // Grid always normalizes tiles into a fixed column grid.
  shouldSizeTilesByContent: () => false,
  getRequiredRunNames: getNoRequiredRunNames,
  getRunFilterMediaKeys: getPanelMediaKeys,
  shouldFilterRunsInQuery: shouldAlwaysFilterRunsInQuery,
  getHistorySpecs: getCombinedHistorySpecs,
  getColumnAxisValueCount: (_gallerySettings, gridSettings, runs, stepMeta) =>
    getAllAxisValues(gridSettings.xAxis, runs, stepMeta).length,
  getPageCap: () => null,
  getLoadTier: ({activeTileCount}) => getGridLoadTier(activeTileCount),
  getPaginationTileTotal: ({layoutTileCount}) => layoutTileCount,
};
